export class ConfigurationModel {
    configurationId: string | undefined;
    groupId: string | undefined;
    productCode: string | undefined;
    configKey: string | undefined;
    value: string | undefined;
    name: string | undefined;
    configurationTypeCode: string | undefined;
    configurationType: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    addConfigurationMatrixModel: AddConfigurationMatrixModel;

    constructor() {
        this.addConfigurationMatrixModel = new AddConfigurationMatrixModel();
    }
}

export class AddConfigurationMatrixModel {
    condition1: string | null = null;
    condition2: string | null = null;
    condition3: string | null = null;
    condition4: string | null = null;
    condition5: string | null = null;
    hasValue: boolean = false;
}